import styled from "styled-components";
import { Header } from "../home-page/landing/landing.components";
import { IoCalendarOutline } from "react-icons/io5";
import { CiClock2 } from "react-icons/ci";
import KnowledgeBase from "./knowledge-base";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const Container = styled.div`
  margin-top: 80px;
`;
const HeaderContainer = styled.div`
  position: relative;
  background: linear-gradient(60deg, var(--chakra-colors-primary), #882446);
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-direction: column;
`;
const DateContainer = styled.div`
  display: flex;
  gap: 32px;
`;
const Date = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;
const Time = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;
const Img = styled.img`
  margin-top: -100px;
  z-index: 1;
  position: relative;
  border-radius: 16px;
  -webkit-box-shadow: 0px 0px 8px 0px rgb(0, 0, 0);
  -moz-box-shadow: 0px 0px 8px 0px rgb(0, 0, 0);
  box-shadow: 0px 0px 8px 0px rgb(0, 0, 0);
  margin-left: auto;
  margin-right: auto;
`;
const Content = styled.div`
  margin-top: 100px;
`;

function Article({ title, image, metaDescription, metaKeywords, timeToRead, date, children }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Container>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={metaKeywords} />
            </Helmet>
            <HeaderContainer>
                <Header>{title}</Header>
                <DateContainer>
                    <Date>
                        <IoCalendarOutline size={24} />
                        <span>{date}</span>
                    </Date>
                    <Time>
                        <CiClock2 size={24} />
                        <span>{timeToRead} minuty czytania</span>
                    </Time>
                </DateContainer>
            </HeaderContainer>
            <Img src={image} alt={title} />
            <Content>{children}</Content>
            <KnowledgeBase title="Może również Cię zainteresować" ignore={title} />
        </Container>
    );
}

export default Article;
